import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type BadgeVariant = 'blue' | 'green' | 'yellow' | 'red' | 'gray' | 'purple';

@Component({
  selector: 'app-badge',
  imports: [CommonModule],
  template: `
    <span
      class="px-2 py-1 rounded-full text-xs font-medium"
      [ngClass]="variantClasses"
    >
      <ng-content></ng-content>
    </span>
  `
})
export class BadgeComponent {
  @Input() variant: BadgeVariant = 'blue';

  private readonly variantMap: Record<BadgeVariant, string> = {
    blue: 'bg-item-blue-bg text-item-blue-text',
    green: 'bg-item-green-bg text-item-green-text',
    yellow: 'bg-item-yellow-bg text-item-yellow-text',
    red: 'bg-item-red-bg text-item-red-text',
    gray: 'bg-item-gray-bg text-gray-700',
    purple: 'bg-purple-100 text-purple-800'
  };

  get variantClasses(): string {
    return this.variantMap[this.variant];
  }
}
